import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
@Component({
  selector: 'app-mat-input',
  templateUrl: './mat-input.component.html',
  styleUrls: ['./mat-input.component.scss']
})
export class MatInputComponent implements OnInit {

  @Input('column') column;
  @Input('inputDisable') inputDisable;
  @Input('row') row;
  @Input('singleJob') jobId
  selectedJob
  @Output() marksChanged: EventEmitter<any> = new EventEmitter<any>();
  user: any;
  details
  constructor() {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
  }

  ngOnInit() {
    console.log("whata is the value of roww======", this.row);
    console.log("what is the value of column-----------", this.column);


  }


  ngOnChanges(changes: SimpleChanges): void {

    if (changes.row && changes.row.currentValue) {
      this.details = changes.row.currentValue
    }

    if (changes.jobId && changes.jobId.currentValue) {
      this.selectedJob = changes.jobId.currentValue
    }

  }

  change(event, column, row) {
    this.marksChanged.emit({ event: event, column, row })
    console.log("event emitted")
  }


}
